import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuthStore } from "@/features/auth/auth.store";

export const Route = createFileRoute("/_auth")({
  component: RouteComponent
});

function RouteComponent() {
  const loggedIn = useAuthStore((s) => s.loggedIn);
  const loading = useAuthStore((s) => s.loading);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!loggedIn) navigate({ to: "/", replace: true });
  }, [loggedIn, loading, navigate]);

  return <Outlet />;
}
